import { useCallback } from "react";
import { getQueryData } from "src/helpers/helpers";
import useFetchAsync from "src/hooks/useFetchAsync";
import { deleteReq, useGet, usePatch, usePost } from "src/http-clients/clients";

export const useCreateProduct = () => {
  return usePost(`/users/vendors/products/create`);
};

export const useGetProducts = ({
  length,
  page,
  search,
}: {
  length: number;
  page: number;
  search?: string;
}) => {
  const offset = page === 1 ? 0 : (page - 1) * length;
  const queryData = getQueryData({ length, offset, search });
  const data = useGet(`/users/vendors/products/list${queryData}`);
  return data;
};

export const useGetProductData = (productId: number) => {
  return useGet(productId ? `/users/vendors/products/${productId}` : null);
};

export const useUpdateProduct = (productId: number) => {
  return usePatch(`/users/vendors/products/${productId}`);
};

export const useDeleteProduct = () => {
  const deleteData = useCallback((productId: number) => {
    return deleteReq(`/users/vendors/products/${productId}`);
  }, []);
  return useFetchAsync(deleteData);
};
